import * as t from 'io-ts';
import { fromNullable } from 'io-ts-types';
import { ChecksumAddress, ProtocolInstance, StaticMarketLegacy, getProtocolInstanceChainId } from '@silo/types';
import { getTokenName, getTokenSymbol } from '@silo/contract-utils';

/**
 * type definitions
 */

export const BasicMarketAsset = t.type({
  id: ChecksumAddress,
  symbol: t.string,
  name: t.string,
  decimals: t.number,
});

export type BasicMarketAsset = t.TypeOf<typeof BasicMarketAsset>;

export const BasicMarkets = t.array(
  t.type({
    id: ChecksumAddress,
    archived: fromNullable(t.boolean, false),
    assets: t.array(BasicMarketAsset),
  })
);

export type BasicMarkets = t.TypeOf<typeof BasicMarkets>;
export type BasicMarket = BasicMarkets[number];

/**
 * constructors
 */
const fromStaticMarket =
  (protocolInstance: ProtocolInstance) =>
  ({ id, archived, marketAssets }: StaticMarketLegacy): BasicMarket => {
    const chainId = getProtocolInstanceChainId(protocolInstance);

    return {
      archived,
      id,
      assets: marketAssets.map(({ inputToken: { id, symbol, name, decimals } }) => ({
        id,
        decimals,
        symbol: getTokenSymbol(chainId, id, symbol),
        name: getTokenName(chainId, id, name),
      })),
    };
  };

export const createBasicMarket = {
  fromStaticMarket,
};
